import React from 'react'
// import dataStore from "../data_store/data.json"
import { useGetData } from '../data_store/getData'
const ActivitiesAndAwards = () => {
    const { mainContent: dataStore, loading } = useGetData()

    return (!loading &&
        <main id="main">
            {/* <!-- ======= Activities & Awards ======= --> */}
            <section id="activities_awards" class="resume section-bg">
                <div class="container">
                    <div class="section-title">
                        <h2>Activities & Awards</h2>
                        <div class="row">
                            <div data-aos="fade-up">
                                <div class="resume-item pb-0">
                                    <ul>
                                        {
                                            dataStore.activities_and_awards.map(value => {
                                                return (<li>
                                                    {<span dangerouslySetInnerHTML={{ __html: value.name }} />}
                                                    {value.date ? <h5>{value.date}</h5> : ''}
                                                    {value.certificate_url && <a href={value.certificate_url} target="_blank">[Certificate]</a>}
                                                </li>)
                                            })
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- End Activities & Awards Section --> */}
        </main>
    )
}

export default ActivitiesAndAwards
